
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"36.69","cy":"23.29","r":"21.89","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M58.77 22.56a23.64 23.64 0 00-22.85 22.78M14.61 24a23.55 23.55 0 0015.94-6.91 23.57 23.57 0 006.91-15.85M52.44 7.54l-31.5 31.5M52.44 39.04l-31.5-31.5M12.57 35.5L2.43 45.64M16.99 42.99L1.23 58.76M24.48 47.41L13.84 58.05","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    